import React, { useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';

import Article from '../../../../../landing-page/components/featured-article';
import { plainText } from '../../../../../editorial-content/components/slices/rich-text';

import * as S from './styles';

import { PrismicArticle } from '../../../../../../types';

type Props = {
  article: PrismicArticle;
};

export default function FeaturedArticle({ article }: Props) {
  const { t } = useContext(AppContext);

  return (
    <S.Featured>
      <Article
        imageUrl={article.data.featuredImage?.url}
        pathName={article.pathName}
        title={plainText(article.data.title)}
        preamble={plainText(article.data.metaDescription)}
        linkText={t('landing', 'featured-article.read-more')}
      />
    </S.Featured>
  );
}
